import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import AssetBookingManagementOfficerWidgets from '../../../widgets/assetBookingManagementWidgets/AssetBookingManagementOfficerWidgets'
import { getAssetBookingManagement } from '../../../redux/actions/assetBookingManagement'

export default function AssetBookingManagementOfficer() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetBookingManagement(1, 5)
      console.log('ggggg ', _schema)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssetCirculating>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssetCirculating>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAssetCirculating>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <AssetBookingManagementOfficerWidgets schema={schema.form} />

        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  header: 'จัดการรายการขอจองครุภัณฑ์',
  subHeader: '',
  disabled: false,
  form: {
    header: 'รายการคำขอปิดครุภัณฑ์โครงการ',
    searchForm: {
      header: 'ค้นหารายการจอง',
      reserveDocNo: {
        name: 'reserveDocNo',
        label: 'เลขที่คำขอจอง',
        value: '',
      },
      project: {
        label: 'โครงการ',
        name: 'project',
        value: '',
      },
      reserveStartDate: {
        label: 'วันที่ขอจองเริ่มต้น',
        name: 'reserveStartDate',
        value: '',
      },
      reserveEndDate: {
        label: 'วันที่ขอจองสิ้นสุด',
        name: 'reserveEndDate',
        value: '',
      },
      reserveExpiredStartDate: {
        label: 'วันที่หมดอายุการจองเริ่มต้น',
        name: 'reserveExpiredStartDate',
        value: '',
      },
      reserveExpiredEndDate: {
        label: 'วันที่หมดอายุการจองสิ้นสุด',
        name: 'reserveExpiredEndDate',
        value: '',
      },
      reserveStatus: {
        label: 'สถานะ',
        name: 'reserveStatus',
        value: '',
        options: [],
      },
    },
    result: {
      totalSize: 0,
      values: [
        {
          id: '1',
          reserveDocNo: '22',
          reserveDate: '33',
          reserveExpiredDate: '44',
          assetCount: '55',
          reserveStatus: '66',
          reserver: '77',
          reserveToProject: '88',
        },
      ],
    },
  },
}
